import { VehicleStatus as Status } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface VehicleStatusesState extends EntityState<Status> {}

export const vehicleStatusesAdapter: EntityAdapter<Status> = createEntityAdapter<Status>({
  selectId: (vehicleStatus: Status) => vehicleStatus.id
});

export const initialState: VehicleStatusesState = vehicleStatusesAdapter.getInitialState({ loading: true });
export const vehicleStatusesSelector = createSelector(
  svcDropdownsFeatureSelector,
  (state: any) => state.vehicleStatuses
);

export const { selectIds, selectEntities, selectAll, selectTotal } = vehicleStatusesAdapter.getSelectors(
  vehicleStatusesSelector
);
